import {Pipe, PipeTransform} from '@angular/core';
import {DeliveryNoteLineType, LinesDto} from '../../../Models/Purchases/Shared/line.interface';

@Pipe({
  name: 'deliveryNotesLines',
  standalone: false
})
export class DeliveryNotesLinesPipe implements PipeTransform {

  transform(items: LinesDto[], filter: { type: DeliveryNoteLineType[] }): LinesDto[] {

    if (!items?.length) {
      return [];
    }

    if (filter.type?.length) {
      items = items.filter((item) => filter.type.includes(item.type));
    }

    return items;

  }

}
